module.exports = __webpack_public_path__ + "img/success.70ffafd1.svg";